export enum INSTANCE_BACK_OFFICE {
    /**
     * @value Change site
     */
    CHANGE_SITE = 'INSTANCE_BACK_OFFICE.CHANGE_SITE',
    /**
     * @value Sites
     */
    INSTANCES_TITLE = 'ADMIN.NAV.INSTANCES.TITLE',
    /**
     * @value Sites management
     */
    MANAGEMENT = 'ADMIN.NAV.INSTANCES.MANAGEMENT',
}
